import { GridState } from '@mui/x-data-grid-premium'
import { safeParseJson } from '@omnea-app/packages/universal/json-utils/safeParseJson'
import { getTableStateLocalStorageKey } from '../../data-grid/DataGridBase'

export function getTableStateFromLocalStorage(tableName?: string | null): GridState | null {
  if (!tableName) return null

  const storageKey = getTableStateLocalStorageKey(tableName)
  const tableState = localStorage.getItem(storageKey)
  const parsedTableState = safeParseJson<GridState>(tableState)

  return parsedTableState
}
